import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Skeleton } from "../components/ui/skeleton";
import { Seo } from "../components/Seo";

const NAMES = {
  "gift-boxes": "Gift Boxes", "dry-fruits": "Dry Fruits", "nuts": "Nuts", "seeds": "Seeds",
  "berries": "Berries", "exotic-collection": "Exotic Collection", "corporate-gifts": "Corporate Gifts",
};
const TAGLINES = {
  "gift-boxes": "Curated luxury hampers for every celebration.",
  "dry-fruits": "Nature's sweetness, sun-ripened and pure.",
  "nuts": "Handpicked, roasted to perfection.",
  "seeds": "Tiny powerhouses of nutrition.",
  "berries": "Antioxidant-rich, sweet and tart.",
  "exotic-collection": "Rare, premium and gloriously indulgent.",
  "corporate-gifts": "Impress clients and teams, at scale.",
};

export default function CategoryPage() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category: slug } }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="fade-in">
      <Seo title={NAMES[slug] || slug} description={TAGLINES[slug] || "Premium dry fruits and nuts from Aadvan, Sitapur."} image={products[0]?.images?.[0]} />
      <div className="bg-forest text-cream py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-2">
            <Link to="/products" className="hover:underline">Shop</Link> / {NAMES[slug] || slug}
          </div>
          <h1 className="font-serif text-5xl lg:text-6xl">{NAMES[slug] || slug}</h1>
          <p className="text-cream/70 mt-3 max-w-xl">{TAGLINES[slug]}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[...Array(4)].map((_, i) => <Skeleton key={i} className="aspect-square rounded-xl" />)}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-24 text-muted-foreground">No products in this category yet.</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-testid="category-grid">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
